
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/About/About.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./About.html');
        
        var script = require('./About.ts').default;
        module.exports = require('./About.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    